import React, { useEffect, useRef } from "react";
import { CircuitBoard, Mail, User } from "lucide-react";
import "./AddNodeMenu.scss";

const AddNodeMenu = ({ position, onSelect, onClose }) => {
  const menuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        onClose();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [onClose]);

  return (
    <div
      ref={menuRef}
      className='add-node-menu'
      style={{
        position: "fixed", // Use fixed positioning relative to viewport
        left: `${position.x}px`,
        top: `${position.y}px`,
        zIndex: 1000,
      }}>
      <div className='menu-header'>Add Node</div>

      <div className='menu-item' onClick={() => onSelect("assignNode")}>
        <User className='lucid-icon-common menu-icon' />
        <span className='menu-text'>Assign Node</span>
      </div>

      <div className='menu-item' onClick={() => onSelect("switchNode")}>
        <CircuitBoard className='lucid-icon-common menu-icon' />
        <span className='menu-text'>Switch Node</span>
      </div>

      <div className='menu-item' onClick={() => onSelect("emailNode")}>
        <Mail className='lucid-icon-common menu-icon' />
        <span className='menu-text'>Email Node</span>
      </div>
    </div>
  );
};

export default AddNodeMenu;
